var map = {
	"./social-500px.svg": 116,
	"./social-dribbble.svg": 117,
	"./social-facebook.svg": 118,
	"./social-github.svg": 119,
	"./social-google.svg": 120,
	"./social-instagram.svg": 121,
	"./social-odnoklassniki.svg": 122,
	"./social-rediit.svg": 123,
	"./social-stackoverflow.svg": 124,
	"./social-steam.svg": 125,
	"./social-twitch.svg": 126,
	"./social-twitter.svg": 127,
	"./social-vkontakte.svg": 128,
	"./social-windows.svg": 129,
	"./social-yahoo.svg": 130
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 115;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars ^\.\/social\-.*\.svg$
// module id = 115
// module chunks = 0